module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FrJXfa/tc-custom/cover.jpg?1685327250429?1706994729008",
      "alt": "This image is the cover for the book Finding Their Voices"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Finding Their Voices\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("Finding Their Voices")]), _vm._v(" is more than a book of sermons. It seeks to honor a generation of women who stand at the headwaters of a stream of change in Churches of Christ in regards to women in ministry. It records history in the making and preserves the words spoken by 29 women from pulpits across the U.S. and Canada. It also recognizes the churches and institutions that welcomed these women and provided space for their voices to be heard.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      D'Esta Love\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("D'Esta Love was Pepperdine University's first chaplain and now holds the honorary title chaplain emerita. Author of John, Light in the Darkness (ACU Press), she is also co-editor with her husband, Stuart, of Leaven, a journal devoted to ministry for churches of the Stone-Campbell movement. She received an MDiv from Pepperdine University. D'Esta has been a tireless leader and mentor to women in Churches of Christ, helping them find their voices and encouraging churches to fully embrace their gifts. She and Stuart have been married for 56 years. They have two sons, Mark and Jon, five grandsons, Zachary, Nicholas, Noah, and Andrzej, and one great-granddaughter, Haven Abigail Love.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    ACU Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0